/*
* Salla Branches Component: Store branches & warehouses popup modal
* You can use these classes to target the elements in the component.
*/

.s-scopes-availability-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.s-scopes {
  &-title {}

  &-container {
  }

  &-input-wrap {}

  &-input {}

  &-label {}

  &-select {}

  &-space-v {}

  &-sr-only {}

  &-is-closed {}

  &-closed-badge {}

  &-clickable {}

  &-submit {}

  &-color-red {}

  &-color-green {}

  &-color-gray {}

  &-placeholder {
    flex: 0 0 85%;
  }
}
